import { CommonListQuery, ProductCategory } from "../../redux/api/apiTypes"
import { AuctionResponse, BidderDetail, Product } from "../auction/types"
import { ContractDetail, User } from "../common/types/types"

export const profileIDTypes = {
    FRONT: 'front',
    BACK: 'back',
    ORGANIZATION: 'organization',
}

export interface ChangePassword {
    confirmPass: string,
    newPass: string,
    oldPass: string,
}

export interface ProductCareSearch extends CommonListQuery {
    fromAcceptPrice?: number,
    fromStartAuctionDate?: string,
    fromStartPrice?: number,
    productName?: string,
    startStatus?: number,
    toAcceptPrice?: number,
    toStartAuctionDate?: string,
    toStartPrice?: number,
    type?: number,
    categoryCodes?: string[],
}

export interface AuctionHistoryResponse {
    auctionStatus: number,
    bidderId: number,
    createdBy: string,
    createdDate: number,
    createdDateStr: string,
    identityCode?: string,
    isDelete: number,
    modifiedDate: number,
    preCostStatus: number,
    preCostStatusStr: string,
    product: Product,
    registerStatus: number,
    registerStatusStr: string,
    status: number,
    user: User,
    bidderRegisterHistories?: BidderRegisterHistory[],
    files: ListResponseFile[],
    fileDoiSoatTienDatTruoc: ListResponseFile[],
    fileStr: string,
    statuteOfBidder?: any,
    note?: string,
}

export interface AuctionHistoryList {
    content: AuctionHistoryResponse[],
    totalElements: number,
}

export interface AuctionHistorySearch extends CommonListQuery {
    auctionStatus?: number,
    identityCode?: string,
    preCostStatus?: number,
    productName?: string,
    registerStatus?: number,
}

export interface BidderRegisterHistory {
    action: string,
    bidderRegisterHistoryId: number,
    createdDate: number,
    isDelete: number,
    modifiedDate: number,
    preCostAction: string,
    preCostStatus: number,
    registerStatus: number,
    userId: string,
    fileDangKys?: BidderRegisterHistoryFile[],
    fileDoiSoatTienDatTruoc?: BidderRegisterHistoryFile[],
}

export interface BidderRegisterHistoryFile {
    fileName: string,
    fileUrl: string,
    objectType: number,
}

export interface PrepayResponse {
    id: number,
    tradingCode: string,
    amount: number,
    tradingStatus: number,
    tradingDate: number,
    createdDate?: number,
    product: Product,
    bidder: BidderDetail,
    filesBienLai: ListResponseFile[],
    filesBienLaiStr?: string,
    statute?: any,
}

export interface ListResponseFile {
    fileName: string,
    fileUrl: string,
    objectType: number,
    storageType?: string,
}

export interface PrepayList {
    content: PrepayResponse[],
    totalElements: number,
}

export interface PrepaySearch extends CommonListQuery {
    bidderId?: number,
    phoneNumber?: string,
    productCode?: string,
    productId?: number,
    statuteCode?: string,
    tradingFromDate?: string,
    tradingStatus?: string,
    tradingToDate?: string,
    tradingValueFrom?: number,
    tradingValueTo?: number,
    userId?: number,
}

export interface PrepayAuction {
    amount: number,
    productId: number,
    tradingTime: string,
    userId: number,
}

export interface AuctionRegisterHistorySearch extends CommonListQuery {
    categoryCode?: string,
    fromDate?: string,
    fromDateContract?: string,
    productCode?: string,
    productName?: string,
    sellerId?: number,
    startPriceBegin?: number,
    startPriceTo?: number,
    startStatus?: number,
    status?: number,
    statusContract?: number,
    statusContracts?: number[],
    statuteCode?: string,
    statuteId?: number,
    toDate?: string,
    toDateContract?: string,
    type?: number,
}

export interface AuctionRegisterHistoryResponse {
    contractId: number,
    contractNumber: string,
    createdBy: string,
    createdDate: number,
    createdDateStr: string,
    isDelete: number,
    modifiedBy: string,
    modifiedDate: number,
    products: AuctionResponse[],
    seller: User,
    status: number,
    fileHopDong?: ListResponseFile[],
}

export interface AuctionRegisterHistoryList {
    content: AuctionRegisterHistoryResponse[],
    totalElements: number,
}

export interface ProductDetailResponse {
    contract: ContractDetail,
    createdBy: string,
    createdDate: number,
    categories: ProductCategory[],
    description: string,
    fileHoSos: ListResponseFile[],
    isDelete: number,
    modifiedBy: string,
    modifiedDate: number,
    productId: number,
    productType: number,
    productName: string,
    startPrice: number,
    startStatus: number,
    status: number,
}